import { LayoutAnimation } from 'react-native'

export const addEasing = () => {
  LayoutAnimation.configureNext({
    duration: 200,
    create: { type: 'linear', property: 'opacity', duration: 200 },
    delete: { type: 'linear', property: 'opacity' },
  })
}
